let _authorize = null;
//public keys
const STATE_VERSION = "STATE_VERSION";
const ROLE_CONTEXT = "ROLE_CONTEXT";

//values
const STATE_VERSION_NUMBER = "1.0.0";
const ROLE_CONTEXT_CRO = "ROLE_CONTEXT_CRO";
const ROLE_CONTEXT_INVESTIGATOR = "ROLE_CONTEXT_INVESTIGATOR";
const ROLE_CONTEXT_PATIENT = "ROLE_CONTEXT_PATIENT";

const keys = {
  //Keys
  STATE_VERSION,
  ROLE_CONTEXT,
};

const consts = {
  //const values
  STATE_VERSION_NUMBER,
  ROLE_CONTEXT_CRO,
  ROLE_CONTEXT_INVESTIGATOR,
  ROLE_CONTEXT_PATIENT,
};

const init = ({ authorize }) => {
  !_authorize && (_authorize = authorize);
};

const STATE = {
  [STATE_VERSION]: STATE_VERSION_NUMBER,
  [ROLE_CONTEXT]: null,
};

const reloadState = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 923795,
    };
  }
  return STATE;
};

const setValue = (authorize, keyName, value) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 198637,
    };
  }
  STATE[keyName] = value;
};

const reset = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 688609,
    };
  }
  STATE[STATE_VERSION] = STATE_VERSION_NUMBER;
  STATE[ROLE_CONTEXT] = null;
};

const AppContextState = {
  //Keys
  KEYS: { ...keys },
  ...keys,

  //Values
  CONSTS: { ...consts },
  ...consts,

  init,
  setValue,
  reset,
  reloadState,
};

export default AppContextState;

export {
  keys as KEYS,
  consts as CONSTS,
  STATE_VERSION,
  STATE_VERSION_NUMBER,
  ROLE_CONTEXT,
  ROLE_CONTEXT_CRO,
  ROLE_CONTEXT_INVESTIGATOR,
  ROLE_CONTEXT_PATIENT,
};
